import React, { useContext } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { getSizeTitle } from './utils';
import { ButtonText } from './styles';

export const SizeVariantsButtonLabel = () => {
  const { t, market } = useAppContext();
  const { selectedSizeVariants } = useContext(PriceListFilterContext);
  const title = getSizeTitle(t, market);
  const selectedVariants =
    (selectedSizeVariants?.length && selectedSizeVariants.sort().join(', ')) ??
    t('product', 'variants.all');
  const buttonText = `${title}: ${selectedVariants}`;

  return (
    <ButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>{buttonText}</TitleSmallText>
    </ButtonText>
  );
};
